import { Box, Stack, Table, Text, Title } from '@mantine/core'
import MultiLineText from '~/components/multi-line-text'

// components should define their own input prop types
type Props = {
  data: {
    jobDescription: string
    hrMessage: string
    entryFlow: string
    startingSalary: string
    bonus: string
    workplace: string
    workTime: string
    holidays: string
    allowances: string
    welfare: string
    training: string
    openPositionsCount: string
    passiveSmokingPolicy: string
    employmentType: string
    applicationRequirements: string
    isAvailable: boolean
  }
}

const PROJECT_YEAR = import.meta.env.VITE_PROJECT_YEAR

export const JobDescription = (props: Props) => {
  const { data } = props
  return (
    <>
      {!data.isAvailable ? (
        <Box my='xl'>
          <Text c='error' fw='bold'>
            ※こちらの情報は過去の採用のものとなります。{PROJECT_YEAR}
            卒採用情報が出次第更新いたします。
          </Text>
        </Box>
      ) : null}

      <Title order={3} c='primary' my='xl'>
        募集要項
      </Title>

      <Table
        variant='vertical'
        styles={{ th: { backgroundColor: 'transparent' } }}
        withTableBorder={false}
      >
        <Table.Tbody>
          {data.employmentType && (
            <Table.Tr>
              <Table.Th w={80} py='xl' px={0} hiddenFrom='sm'>
                <Title order={4}>雇用区分</Title>
              </Table.Th>
              <Table.Th w={160} py='xl' px={0} visibleFrom='sm'>
                <Title order={4}>雇用区分</Title>
              </Table.Th>
              <Table.Td>
                <MultiLineText>{data.employmentType}</MultiLineText>
              </Table.Td>
            </Table.Tr>
          )}

          {data.jobDescription && (
            <Table.Tr>
              <Table.Th w={80} py='xl' px={0} hiddenFrom='sm'>
                <Title order={4}>
                  募集職種・
                  <br />
                  仕事内容
                </Title>
              </Table.Th>
              <Table.Th w={160} py='xl' px={0} visibleFrom='sm'>
                <Title order={4}>
                  募集職種・
                  <br />
                  仕事内容
                </Title>
              </Table.Th>
              <Table.Td>
                <MultiLineText>{data.jobDescription}</MultiLineText>
              </Table.Td>
            </Table.Tr>
          )}

          {data.applicationRequirements && (
            <Table.Tr>
              <Table.Th w={80} py='xl' px={0} hiddenFrom='sm'>
                <Title order={4}>応募資格</Title>
              </Table.Th>
              <Table.Th w={160} py='xl' px={0} visibleFrom='sm'>
                <Title order={4}>応募資格</Title>
              </Table.Th>
              <Table.Td>
                <MultiLineText>{data.applicationRequirements}</MultiLineText>
              </Table.Td>
            </Table.Tr>
          )}

          {data.hrMessage && (
            <Table.Tr>
              <Table.Th w={80} py='xl' px={0} hiddenFrom='sm'>
                <Title order={4}>
                  人事からの
                  <br />
                  メッセージ
                </Title>
              </Table.Th>
              <Table.Th w={160} py='xl' px={0} visibleFrom='sm'>
                <Title order={4}>
                  人事からの
                  <br />
                  メッセージ
                </Title>
              </Table.Th>
              <Table.Td>
                <MultiLineText>{data.hrMessage}</MultiLineText>
              </Table.Td>
            </Table.Tr>
          )}

          {data.entryFlow && (
            <Table.Tr>
              <Table.Th w={80} py='xl' px={0} hiddenFrom='sm'>
                <Title order={4}>採用の流れ</Title>
              </Table.Th>
              <Table.Th w={160} py='xl' px={0} visibleFrom='sm'>
                <Title order={4}>採用の流れ</Title>
              </Table.Th>
              <Table.Td>
                <MultiLineText>{data.entryFlow}</MultiLineText>
              </Table.Td>
            </Table.Tr>
          )}

          {data.jobDescription && (
            <Table.Tr>
              <Table.Th w={80} py='xl' px={0} hiddenFrom='sm'>
                <Title order={4}>採用データ</Title>
              </Table.Th>
              <Table.Th w={160} py='xl' px={0} visibleFrom='sm'>
                <Title order={4}>採用データ</Title>
              </Table.Th>
              <Table.Td>
                <Stack>
                  <Title order={4}>初任給</Title>
                  <MultiLineText mb='xs'>{data.startingSalary}</MultiLineText>
                  <Title order={4}>昇給・賞与</Title>
                  <MultiLineText mb='xs'>{data.bonus}</MultiLineText>
                  <Title order={4}>勤務地</Title>
                  <MultiLineText mb='xs'>{data.workplace}</MultiLineText>
                  <Title order={4}>勤務時間</Title>
                  <MultiLineText mb='xs'>{data.workTime}</MultiLineText>
                  <Title order={4}>休日・休暇</Title>
                  <MultiLineText mb='xs'>{data.holidays}</MultiLineText>
                  <Title order={4}>諸手当</Title>
                  <MultiLineText mb='xs'>{data.allowances}</MultiLineText>
                  <Title order={4}>福利厚生</Title>
                  <MultiLineText mb='xs'>{data.welfare}</MultiLineText>
                  <Title order={4}>教育・研修制度</Title>
                  <MultiLineText mb='xs'>{data.training}</MultiLineText>
                  <Title order={4}>採用人数</Title>
                  <MultiLineText>{data.openPositionsCount}</MultiLineText>
                  {data.passiveSmokingPolicy ? (
                    <>
                      <Title order={4}>就業場所における受動喫煙防止措置</Title>
                      <MultiLineText>{data.passiveSmokingPolicy}</MultiLineText>
                    </>
                  ) : null}
                </Stack>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </>
  )
}
